'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.toRGBANoWhite = exports.toRGBA = exports.colorStringToRGBA = void 0;
const colorStringToRGBA = color => {
  if (color.trim().indexOf('rgb') === 0) {
    const values = color.replace(/rgba?\((.+)\)/, '$1');
    const [r, g, b, a] = values.split(',');
    return {
      a: parseInt(a || '1', 10),
      b: parseInt(b, 10),
      g: parseInt(g, 10),
      r: parseInt(r, 10),
    };
  }
  if (color.trim().indexOf('#') === 0) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    const [, r, g, b] = result || [];
    return {
      b: parseInt(b, 16),
      g: parseInt(g, 16),
      r: parseInt(r, 16),
    };
  }
  if (color.trim().indexOf('{') === 0) {
    return JSON.parse(color);
  }
  return { b: 0, g: 0, r: 0 };
};
exports.colorStringToRGBA = colorStringToRGBA;
const toRGBA = (color, alpha = 1) => {
  const c = typeof color === 'string' ? colorStringToRGBA(color) : color;
  return c ? `rgba(${c.r}, ${c.g}, ${c.b}, ${alpha || c.a})` : '';
};
exports.toRGBA = toRGBA;
const toRGBANoWhite = (color, backup, alpha = 1) => {
  // fallback for the backup
  const fallback = '#ccc';
  // if there is no color, run again with backup and fallback
  if (!color) return toRGBANoWhite(backup, fallback, alpha);
  const c = typeof color === 'string' ? colorStringToRGBA(color) : color;
  if (
    // any of the options are not 255
    c.r === 255 &&
    c.b === 255 &&
    c.g === 255
  ) {
    // color was white, run again with backup and fallback
    return toRGBANoWhite(backup, fallback, alpha);
  }
  return toRGBA(c, alpha);
};
exports.toRGBANoWhite = toRGBANoWhite;
